import classNames from 'classnames';
import styles from './uploader.module.scss';

type TUploaderProps = {
  setFile: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
};

const Uploader = ({setFile}: TUploaderProps) => {
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {files} = e?.target;
    if (files && files[0]) {
      setFile(prev => [
        ...prev,
        {isSelected: prev?.length === 0 ? true : false, file: files?.[0]},
      ]);
    }
  };

  return (
    <>
      <div
        className={classNames(
          styles['uploader'],
          'border border-dashed border-primary',
        )}
      >
        <input type="file" onChange={handleUpload} accept=".jpg, .jpeg" />
        <div className={classNames(styles['uploader__icon'], ' text-primary')}>
          <i className="icon-gallery text-primary"></i>
        </div>
      </div>
    </>
  );
};

export default Uploader;
